import { AppColors } from 'src/resources/app_colors';
import { AppIcons } from 'src/resources/app_icons';

const fallbackBaseUrl = 'https://focali-qa.speehive.net';
const baseUrl = typeof window !== 'undefined' ? window.location.origin : fallbackBaseUrl;

const invoiceParserBaseUrl = 'https://fi-invoice-parser-qa.azurewebsites.net/';
const invoiceParserKey = 'f47ac10b-58cc-4372-a567-0e02b2c3d479';

const baseWarehouseAppUrl = 'https://wms-qa-ephtd4ejdff8bzas.centralindia-01.azurewebsites.net/warehouse-console/dashboard';

const baseWarehouseApiUrl =
  'https://wms-qa-ephtd4ejdff8bzas.centralindia-01.azurewebsites.net/';

const appVersion = require('../../package.json').version + '-qa';

export const environment = {
  appVersion,

  primaryColor: '#FFD080',
  secondaryColor: AppColors.secondaryDullOrange,

  production: false,
  baseName: 'focali-qa',
  hostDomain: 'focali-qa.speehive.net',

  invoiceParserBaseUrl,
  baseWarehouseAppUrl,
  baseWarehouseApiUrl,
  invoiceParserKey,

  hmr: false,

  application: {
    baseUrl,
    name: 'Focali',
    logoUrl: AppIcons.appIconPath,
  },

  oAuthConfig: {
    issuer: 'https://focal-qa-api.azurewebsites.net/',
    clientId: 'AgencyPlatform_App',
    redirectUri: `${baseUrl}/signin-callback`,
    postLogoutRedirectUri: `${baseUrl}/signout-callback`,
    responseType: 'code',
    scope: 'offline_access openid profile email roles AgencyPlatform',
    requireHttps: true,
    strictDiscoveryDocumentValidation: false,
    disablePKCE: false,
    // Sent with the sign-in request so the server login page can show the app version.
    customQueryParams: { app_version: appVersion },
  },

  apis: {
    default: {
      url: 'https://focal-qa-api.azurewebsites.net/',
      rootNamespace: 'AgencyPlatform',
    },
  },

  appInsights: {
    instrumentationKey: '436724a3-eac8-4e08-8599-a0de71af951b',
  },

  googleAnalytics: {
    measurementId: '',
  },

  webPush: {
    publicKey:
      'BEL-O4IUpkHPn3V4vB9OX9c2o-KIq-yIT6ilzJCZ372RN_iUR18PzYxNGFCl5oJtabTHPGEguEepictUHzddolE',
    privateKey: 'ywN0xjozJYIx2HKiPaWxFC6NKNSMi7xH55Dy4k429Gg',
  },

  firebase: {
    apiKey: 'AIzaSyD4i5JbafzNXA0m4IYp8SSiUgwNutCsUD0',
    authDomain: 'focali-dev-app.firebaseapp.com',
    projectId: 'focali-dev-app',
    storageBucket: 'focali-dev-app.firebasestorage.app',
    messagingSenderId: '426621576793',
    appId: '1:426621576793:web:5f295a4b039ad4ae94f348',
    measurementId: 'G-VB9JEQECGQ',
    vapidKey:
      'BHbY_i4c5hoEzQ5_IZAOAFQfZHbRP6i8jt2qhs_aAbAHFaVFSLGBWxJi26w4xhWldXDfgF9Ckv8LZsEXK1BHI9I',
  },
};
